export const iconButtonHeight = {
  default: "min-h-11",
  fit: "py-2",
  compact: "",
};

export type Height = keyof typeof iconButtonHeight;
